import { GuestBot } from "../../interfaces"

export interface BindingRow {
  id?: string
  triggerText: string
  templateId: string
  isFallback: boolean
}

export const rowsToBindings = (
  rows: BindingRow[],
): GuestBot.ResponseBinding[] =>
  rows.map((r) => ({
    triggerText: r.isFallback ? null : r.triggerText.trim().toLowerCase(),
    templateId: r.templateId,
  }))

export const bindingsToRows = (
  bindings: GuestBot.ResponseBinding[],
): BindingRow[] =>
  bindings.map((b) => ({
    id: b.id,
    triggerText: b.triggerText ?? "",
    templateId: b.templateId,
    isFallback: b.triggerText === null,
  }))
